import styled from 'styled-components'

import { convertHtmlStringToReactComponents } from '@hozana/dom/functions'
import { Translate } from '@hozana/intl/Translate'

import { Div } from 'elements/layout/Div'
import { Li } from 'elements/layout/Li'
import { Ul } from 'elements/layout/Ul'
import { Icon } from 'elements/media/Icon'
import { H } from 'elements/text/H'

import { ICON } from 'config/icons'

const StyledIcon = styled(Icon)<{ upsideDown?: boolean }>`
  vertical-align: top;
  transition: transform 0.3s;
`

const StyledUl = styled(Ul)`
  line-height: 21px;
  font-size: 14px;
  padding-left: 2px;
`

type TGuideSourcesSectionProps = {
  sources: string[]
}

export const GuideSourcesSection: TFC<TGuideSourcesSectionProps> = ({ sources }) => {
  return sources && sources.length > 0 ? (
    <Div p="22px 0" m="auto" as="section">
      <Div as="button" w={1} align="left" m="0 0 10px" p="0" id="Sources_button">
        <H size="2" fontSize="20px" font="openSans" bold={false} color="blue">
          <Translate>trans:guide:guide.sources-bibliography</Translate>
          <StyledIcon name={ICON.CHEVRON_DOWN} id="Sources_chevron" />
        </H>
      </Div>
      <StyledUl as="ol" align="left" listStyle="inside decimal" id="Sources_content">
        {sources.map((source, index) => (
          <Li key={index} p="0 0 6px">
            {convertHtmlStringToReactComponents(source)}
          </Li>
        ))}
      </StyledUl>
    </Div>
  ) : null
}
